import React, { useEffect, useRef } from 'react';
import { ISelectOption } from '@creditflowresearch/uilib/Select';
import { useLeagueTableContext } from '@/creditflowresearch/application/League/Table/LeagueTableContext';
import { useRouter } from '@framework/router';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';
import { usePageFiltersStateContext } from '@/creditflowresearch/application/PageFiltersState/PageFiltersStateContext';
import TTMSelect from '@/creditflowresearch/ui/common/components/atoms/TTMSelect';

const TopUnderwritersTTMSelect = () => {
  const { query: { products, regions } } = useRouter();
  const didMount = useRef(false);
  const { paginateTopUnderwriters } = useLeagueTableContext();
  const {
    state: filtersState,
    getTopUnderwritersPeriods,
    resetTopUnderwritersPeriod,
    setTopUnderwritersPeriod,
  } = useLeagueTableFiltersContext();

  const selectedPeriod = filtersState.periods.topUnderwriters.selected;
  const periodsCollection = filtersState.periods.topUnderwriters.collection;

  const {
    state: {
      productIds: includedProductIds,
      regionIds: includedRegionIds,
    },
  } = usePageFiltersStateContext();

  const onChange = (option: ISelectOption): void => {
    if (option) {
      setTopUnderwritersPeriod(option);
      paginateTopUnderwriters(1);
    }
  };

  useEffect(() => () => {
    resetTopUnderwritersPeriod();
  }, []);

  useEffect(() => {
    if (didMount.current) {
      getTopUnderwritersPeriods({ includedProductIds, includedRegionIds });
    } else {
      didMount.current = true;
    }
  }, [products, regions]);

  return (
    <TTMSelect
      value={ selectedPeriod }
      options={ periodsCollection }
      onChange={ onChange }
      isOptionDisabled={ (option) => option.disabled }
      dataTest="topUnderwritersTTMFilter"
    />
  );
};

export default TopUnderwritersTTMSelect;
